import formatters from '@/utils/formatters';
import i18n from '@/main';

export function getMesesAbreviados() {
    return [
        i18n.t('mensagens.home.centralEventos.meses.JAN'),
        i18n.t('mensagens.home.centralEventos.meses.FEV'),
        i18n.t('mensagens.home.centralEventos.meses.MAR'),
        i18n.t('mensagens.home.centralEventos.meses.ABR'),
        i18n.t('mensagens.home.centralEventos.meses.MAI'),
        i18n.t('mensagens.home.centralEventos.meses.JUN'),
        i18n.t('mensagens.home.centralEventos.meses.JUL'),
        i18n.t('mensagens.home.centralEventos.meses.AGO'),
        i18n.t('mensagens.home.centralEventos.meses.SET'),
        i18n.t('mensagens.home.centralEventos.meses.OUT'),
        i18n.t('mensagens.home.centralEventos.meses.NOV'),
        i18n.t('mensagens.home.centralEventos.meses.DEZ')
    ];
}

const formatterYProdutividade = unidade => {
    return value => {
        if (!value) {
            return '-';
        }
        return formatters.formatNumber(value) + unidade;
    };
};

export function graficoProdutividadeOptions() {
    return {

        legend: {
            onItemClick: {
                toggleDataSeries: true
            },
            formatter: (seriesName, opts) => {
                switch (opts.seriesIndex) {
                    case 0:
                        return 'Produtividade estimada';
                    // case 1:
                    // 	return 'Produtividade última safra';
                    // case 2:
                    // 	return 'Produtividade média histórica';
                    // case 1:
                    // 	return 'Chuva';
                }
            }
        },
        chart: {
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false
            }
        },
        dataLabels: {
            enabled: true,
            enabledOnSeries: [0]
        },
        plotOptions: {
            bar: {
                columnWidth: '5%'
            }
        },
        xaxis: {
            categories: []
        },
        colors: ['#FFA726', /* '#01A3A4', '#909399',  */ '#D6D951', '#889306'],
        stroke: {
            width: 2
            // dashArray: [0, 4, 4, 0]
        },
        yaxis: {
            seriesName: i18n.t('mensagens.monitoramento.historico.agricola.produtividadeEstimada'),
            title: {
                text: `${i18n.t('mensagens.monitoramento.historico.agricola.produtividade')} (sc/ha)`
            },
            showAlways: true,
            forceNiceScale: true,
            decimalsInFloat: 0,
            min: 0
        },
        /* {
            seriesName: 'Produtividade estimada',
            show: false,
            title: {
                text: 'Produtividade (sc/ha)'
            }
        },
        {
            seriesName: 'Produtividade estimada',
            show: false,
            title: {
                text: 'Produtividade (sc/ha)'
            }
        },
        {
            showAlways: true,
            seriesName: 'Precipitação',
            opposite: true,
            title: {
                text: 'Chuva (mm)'
            }
        } */
        tooltip: {
            y: [
                {
                    formatter: formatterYProdutividade('sc/ha')
                }
                /* {
                    formatter: formatterYProdutividade('sc/ha')
                },
                {
                    formatter: formatterYProdutividade('sc/ha')
                },
                {
                    formatter: formatterYProdutividade('mm')
                } */
            ]
        }
    };
};

export function graficoPluviosidadeAcumulada() {
    return {

        legend: {
            position: 'top',
            onItemClick: {
                toggleDataSeries: true
            }
        },
        plotOptions: {
            bar: {
                columnWidth: '45%',
                borderRadius: 2
            }
        },
        chart: {
            toolbar: {
                show: false
            }
        },
        colors: [
            '#ADD8E6',
            '#87CEEB',
            '#87CEFA',
            '#00BFFF',
            '#1E90FF',
            '#00CED1',
            '#4682B4'
        ],
        stroke: {
            curve: 'smooth',
            width: 2
        },
        yaxis: [
            {
                showAlways: true,
                labels: {
                    formatter: value => {
                        return value.toFixed(0);
                    }
                },
                decimalsInFloat: 0
            }
        ],
        xaxis: {
            categories: getMesesAbreviados(),
            labels: {
                rotate: -45
            }
        },
        tooltip: {
            y: {
                formatter: value => {
                    return formatters.formatNumber(value) + ' mm';
                }
            }
        }
    };
};

export function getGraficoTemperatura() {
    return {
        legend: {
            position: 'top',
            onItemClick: {
                toggleDataSeries: true
            }
        },
        plotOptions: {
            bar: {
                columnWidth: '45%',
                borderRadius: 2
            }
        },
        chart: {
            toolbar: {
                show: false
            }
        },
        xaxis: {
            categories: getMesesAbreviados()
        },
        colors: [
            '#FFA500',
            '#FF8C00',
            '#FF6347',
            '#FFA07A',
            '#FA8072',
            '#B22222',
            '#D2691E'
        ],
        stroke: {
            curve: 'smooth',
            width: 2
        },
        yaxis: [
            {
                showAlways: true,
                labels: {
                    formatter: value => {
                        return value.toFixed(0);
                    }
                }
            }
        ],
        tooltip: {
            y: {
                formatter: value => {
                    return formatters.formatNumber(value) + ' °C';
                }
            }
        }
    };
};

export const GRAFICO_MONITORAMENTO_NDVI = {
    legend: {
        onItemClick: {
            toggleDataSeries: true
        }
    },
    chart: {
        toolbar: {
            show: false
        }
    },
    plotOptions: {
        bar: {
            columnWidth: '10%'
        }
    },
    xaxis: {
        categories: []
    },
    colors: ['#008000', '#42A5F5'],
    stroke: {
        width: 2
    },
    yaxis: [
        {
            seriesName: i18n?.t('mensagens.monitoramento.historico.indiceDeVegetacao'),
            showAlways: true,
            forceNiceScale: true,
            labels: {
                formatter: value => {
                    return formatters.formatNumber(value, 1);
                }
            }
        } /* ,
    {
        showAlways: true,
        seriesName: 'Chuva',
        opposite: true,
        title: {
            text: 'Chuva (mm)'
        }
    } */
    ],
    tooltip: {
        y: [
            {
                formatter: value => {
                    return formatters.formatNumber(value, 2);
                }
            } /* ,
            {
                formatter: formatterYProdutividade('mm')
            } */
        ]
    }
};

export function graficoPrevisaoChuvaTemperatura() {
    return {

        stroke: {
            show: true,
            width: 2,
            curve: 'smooth'
        },
        chart: {
            toolbar: {
                show: false
            }
        },
        colors: ['#2688d5', '#ffc107', '#58d6a7'],
        /* dataLabels: {
            enabled: true,
            enabledOnSeries: [0]
        }, */
        xaxis: {},
        yaxis: [
            {
                seriesName: i18n.t('mensagens.monitoramento.historico.precipitacao'),
                title: {
                    text: `${i18n.t('mensagens.monitoramento.historico.precipitacao')} (mm)`
                }
            },
            {
                seriesName: i18n.t('mensagens.monitoramento.historico.agricola.temperaturaMaxima'),
                opposite: true,
                forceNiceScale: true,
                title: {
                    text: `${i18n.t('mensagens.monitoramento.historico.temperatura')} (°C)`
                }
            },
            {
                seriesName: i18n.t('mensagens.monitoramento.historico.agricola.temperaturaMinima'),
                opposite: true,
                forceNiceScale: true,
                title: {
                    text: `${i18n.t('mensagens.monitoramento.historico.temperatura')} (°C)`
                },
                show: false
            }
        ],
        plotOptions: {
            bar: {
                columnWidth: '50%'
            }
        },
        tooltip: {
            y: [
                {
                    formatter(value) {
                        return formatters.formatNumber(value) + ' mm';
                    }
                },
                {
                    formatter(value) {
                        return formatters.formatNumber(value) + ' °C';
                    }
                },
                {
                    formatter(value) {
                        return formatters.formatNumber(value) + ' °C';
                    }
                }
            ]
        }
    };
};
